import { useState, type FormEvent } from "react";
import { NEW_PASSWORD_MIN } from "shared";
import { api, ApiError } from "../api";
import { useAuth } from "../auth";
import { Footer } from "../components/Footer";

/** Shown instead of the whole app while the signed-in user still holds a temporary password. */
export function ChangePassword() {
  const { refresh, signOut } = useAuth();
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNew] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api("/api/auth/change-password", { method: "POST", body: { currentPassword, newPassword } });
      await refresh();
    } catch (x) {
      setError(x instanceof ApiError ? x.message : "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex flex-1 items-center justify-center p-6">
        <div className="card w-full max-w-sm">
          <h1 className="mb-1 text-lg font-semibold">Choose a new password</h1>
          <p className="mb-4 text-sm text-slate-500">You signed in with a temporary password. Choose your own to continue.</p>
          {error && <p role="alert" className="mb-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
          <form onSubmit={submit} className="flex flex-col gap-3">
            <div><label className="label" htmlFor="current-password">Current password</label>
              <input id="current-password" className="input" type="password" autoComplete="current-password" required
                value={currentPassword} onChange={(e) => setCurrent(e.target.value)} autoFocus /></div>
            <div><label className="label" htmlFor="new-password">New password</label>
              <input id="new-password" className="input" type="password" autoComplete="new-password" required minLength={NEW_PASSWORD_MIN}
                value={newPassword} onChange={(e) => setNew(e.target.value)} />
              <p className="mt-1 text-xs text-slate-500">At least {NEW_PASSWORD_MIN} characters, different from the current one.</p></div>
            <button className="btn-primary justify-center" disabled={busy}>Change password</button>
            <button type="button" className="btn-ghost justify-center" onClick={() => signOut()}>Sign out</button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
